import React, { useState, useEffect } from 'react';
import { withStyles, Button, LinearProgress } from '@material-ui/core';
import classnames from 'classnames';
import DatePicker from '../../../components/DatePicker';
import Checkbox from '@material-ui/core/Checkbox';

// SERVICES
import { getBetterviewReport } from '../../../services';

const styles = theme => ({
  datePicker: {
    padding: 10,
  },
});

export const BetterviewReport = withStyles(styles)(props => {
  const { classes } = props;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [error, setError] = useState('');

  const getBetterviewReportAsync = async () => {
    setError('');

    try {
      setIsGeneratingReport(true);
      await getBetterviewReport({ startDate, endDate });
    } catch (error) {
      setError(error.message);
    } finally {
      setIsGeneratingReport(false);
    }
  };

  const formHasErrors = !startDate || !endDate;

  return (
    // <div className={classes.reportWrapper}>
    <div className={classnames('flex-1', 'col-center-center', 'align-stretch', 'card', 'border-left-green')}>
      <h3 style={{ marginBottom: 36 }}>
        Select a date range to generate and download the closed order report for the selected date range.
      </h3>

      <div className={classnames('row-center-center')}>
        <div className={classnames('col-start-start')} style={{ marginRight: 10 }}>
          <span className={classnames('text-left')}>From:</span>
          <DatePicker selected={startDate} onChange={setStartDate} className={classes.datePicker} />
        </div>
        <div className={classnames('col-start-start')} style={{ marginLeft: 10 }}>
          <span className={classnames('text-left')}>Through:</span>
          <DatePicker selected={endDate} onChange={setEndDate} className={classes.datePicker} />
        </div>
      </div>

      <div>
        <Button
          variant="contained"
          style={{ backgroundColor: formHasErrors ? '#aaa' : 'var(--jmi-blue)', color: 'white', margin: '24px auto' }}
          onClick={getBetterviewReportAsync}
          disabled={formHasErrors || isGeneratingReport}
        >
          Get Report
        </Button>
        <div style={{ visibility: isGeneratingReport ? 'visible' : 'hidden' }}>
          <LinearProgress />
        </div>
        <div style={{ maxWidth: 400, color: 'red' }}>{error}</div>
      </div>
    </div>
  );
});
